import { Component } from "@angular/core";


@Component({
    templateUrl: "./actions.html",
    styleUrls: ['../../nurse-module.css']
})
export class ActionsPage {
    
}